<div class="body">
  <p>
    {{ 'message.get-invite-fail.0.' + tenant | translate }}
    <a
      href="mailto:{{
          'message.get-invite-fail.1.' + tenant | translate
        }}"
      >{{
          'message.get-invite-fail.1.' + tenant | translate
      }}</a
    >{{ 'message.get-invite-fail.2' | translate }}
  </p>
  <div class="d-flex align-items-center justify-content-center py-3">
    <i class="bi bi-exclamation-circle-fill text-danger fs-1"></i>
  </div>
</div>
